// extracted by mini-css-extract-plugin
export default {"tabbar-wrapper":"TabBar_tabbar-wrapper__hLw1X","active-tab":"TabBar_active-tab__lXTkl","tab":"TabBar_tab__RDGdq"};